import { fromUint8Array } from 'js-base64';
import { gzip } from 'pako';
import { Tool } from './base';

export class GoogleSecOpsTool extends Tool {
  public readonly toolName = 'Google SecOps';


  public readonly toolDefaultCCMFieldMappings = {
    access: 'target.process.access_mask',
    accesses: 'target.process.access_mask',
    account_id: 'principal.user.windows_sid',
    account_name: 'src.user.user_display_name',
    action: 'security_result.action',
    alert_type: '',
    application_name: 'network.http.user_agent',
    authentication_method: 'src.application',
    bytes_in: 'network.received_bytes',
    bytes_out: 'network.sent_bytes',
    cipher_suite: '',
    client_issuer: '',
    client_subject: '',
    cloud_platform: '',
    dest_domain: 'target.hostname',
    dest_hostname: 'target.hostname',
    dest_ip: 'target.ip',
    dest_mac: 'target.mac',
    dest_port: 'target.port',
    details: 'metadata.description',
    dns_answer: 'network.dns.answers.name',
    dns_query: 'network.dns.questions.name',
    dns_record_type: 'network.dns.questions.type',
    domain: 'target.hostname',
    email_recipient: 'network.email.to',
    email_sender: 'network.email.from',
    email_subject: 'network.email.subject',
    error_code: 'security_result.description',
    error_message: 'security_result.description',
    event_id: 'metadata.product_event_type',
    event_name: 'metadata.description',
    event_type: 'metadata.event_type',
    file_name: 'target.file.full_path',
    file_path: 'target.file.full_path',
    group_id: 'target.user.group_identifiers',
    hostname: 'principal.hostname',
    identity_principal_id: 'principal.user.windows_sid',
    instance_id: '',
    instance_name: '',
    instance_type: '',
    logon_process: 'target.process.file.full_path',
    logon_type: 'extensions.auth.mechanism',
    md5: 'target.process.file.md5',
    message: 'security_result.description',
    mfa_auth: '',
    name: 'target.application',
    object_loaded: 'target.process.file.full_path',
    object_name: 'target.file.full_path',
    parent_process_cmdline: 'principal.process.command_line',
    parent_process_id: 'principal.process.pid',
    parent_process_name: 'principal.process.file.full_path',
    parent_process_path: 'principal.process.file.full_path',
    pipe_name: 'target.resource.name',
    post_body: '',
    process_cmdline: 'target.process.command_line',
    process_id: 'target.process.pid',
    process_name: 'target.process.file.full_path',
    process_path: 'target.process.file.full_path',
    protocol: 'network.ip_protocol',
    record_id: 'metadata.product_log_id',
    referrer: '',
    region: '',
    registry_key_name: 'target.registry.registry_value_name',
    registry_new_value_name: 'target.registry.registry_value_data',
    registry_old_value_name: 'target.registry.registry_value_data',
    registry_path: 'target.registry.registry_key',
    registry_value_name: 'target.registry.registry_value_data',
    request_method: 'network.http.method',
    request_parameters: 'target.url',
    service: 'target.application',
    service_file_path: 'target.process.file.full_path',
    service_name: 'target.application',
    severity: 'security_result.severity',
    sha256: 'target.process.file.sha256',
    sid: 'principal.user.windows_sid',
    source_user_role: 'principal.user.attribute.roles.name',
    src_hostname: 'principal.hostname',
    src_ip: 'principal.ip',
    src_mac: 'principal.mac',
    src_port: 'principal.port',
    status_code: 'network.http.response_code',
    storage_property_name: '',
    storage_target_object: '',
    target_path: 'target.file.full_path',
    task_category: 'target.resource.resource_type',
    title: '',
    uri: 'target.url',
    url: 'target.url',
    user_access_id: 'target.resource.attribute.permissions.name',
    user_agent: 'network.http.user_agent',
    user_role: 'principal.user.attribute.roles.description',
    user_type: 'principal.user.attribute.roles.description',
    username: 'principal.user.userid'
  };

  public generateSearchPermalink(
    rootURL: string, //https://ggltp.backstory.chronicle.security/
    renderedContent: string,
  ): string {
    const encodedRenderedContent = encodeURIComponent(
      fromUint8Array(gzip(renderedContent)),
    );
    return `${rootURL}search?query=${encodedRenderedContent}`;
  }
}
